export const base_url = process.env.REACT_APP_BASE_URL
export const test_url = "https://066b-49-249-69-186.ngrok-free.app/api/"